{
  "pt": {
    "todo_list": {
      "actions": {
        "add": "Criar lista de tarefas",
        "cancel": "Anular",
        "delete_todo_list": "Eliminar lista",
        "edit": "Editar lista de tarefas",
        "new": "Lista de tarefas",
        "save": "Guardar",
        "title": "Título da lista"
      },
      "attributes": {
        "name": "Título"
      },
      "labels": {
        "assignToLevel": "Atribuir ao nível",
        "createdAt": "Criado em",
        "filter_employee": "Responsável",
        "newTodoList": "Nova lista de tarefas",
        "sort": {
          "created_at_asc": "Mais antigo primeiro",
          "created_at_desc": "Mais recentes primeiro",
          "name_lower_asc": "Título A -> Z",
          "name_lower_desc": "Título Z -> A"
        }
      },
      "phase_out": {
        "body": "Tarefas (versão antiga) deixa de estar disponível no final de 2026. Migra as tarefas de que ainda precisas para Tarefas antes de 1 de janeiro de 2027. Até lá, podes continuar a usar e concluir as tarefas existentes.",
        "title": "Tarefas (versão antiga) vai ser descontinuada"
      },
      "placeholders": {
        "empty": "Não há listas de tarefas aqui"
      },
      "toasts": {
        "create": "Lista de tarefas criada com sucesso",
        "delete": "A lista de tarefas foi eliminada com êxito",
        "update": "A lista de tarefas foi atualizada com êxito"
      },
      "validation": {
        "needTitle": "Título necessário"
      }
    }
  }
}
